module.exports = __webpack_public_path__ + "img/vacation_flow.f6550179.png";